import React from 'react'
import { Grid } from '@material-ui/core'
import styles from './styles.module.css'
import { formatZipCode } from '@/utils/helpers/formatZipCode'

export type ComponentProps = {
  /**
   * Optional key to disabled component
   */
  disabled?: boolean
  /**
   * City value
   */
  city: string
  /**
   * County value
   */
  county: string
  /**
   * State value
   */
  state: string
  /**
   * ZipCode value
   */
  zipCode: string
  /**
   * ZipCode value
   */
  extraInfo: string
  /**
   * ZipCode value
   */
  streetAddress: string
}

export const AddressDetailsReadonly = ({
  city,
  county,
  state,
  zipCode,
  disabled,
  extraInfo,
  streetAddress,
}: ComponentProps): JSX.Element =>
   (
  <>
    <span className={styles.label}>Street Address</span>
    <span className={`${styles.text} ${!streetAddress && styles.empty} ${disabled && styles.disabled}`}>
      {streetAddress || 'Required'}
    </span>
    <Grid container spacing={2} justifyContent="space-between" style={{ padding: 0, marginBottom:20, marginTop:8 }}>
      <Grid item>
        <span className={styles.label}>Apartment, Suite, etc.</span>
        <span className={`${styles.text} ${disabled && styles.disabled}`}>{extraInfo}</span>
      </Grid>
      <Grid item>
        <span className={`${styles.label} ${styles.city}`}>City</span>
        <span className={`${styles.text} ${!city && styles.empty} ${disabled && styles.disabled}`}>
          {city || 'Required'}
        </span>
      </Grid>
    </Grid> 
    <Grid container justifyContent="space-between" style={{ padding: 0 }}>
      <Grid item>
        <span className={styles.label}>State</span>
        <span className={`${styles.text} ${!state && styles.empty} ${disabled && styles.disabled}`}>
          {state || 'Required'}
        </span>
      </Grid>
      <Grid item> 
        <span className={`${styles.label}`}>ZipCode</span>
        <span className={`${styles.text} ${!zipCode && styles.empty} ${disabled && styles.disabled}`}>
          {formatZipCode(zipCode) || 'Required'}
        </span>
      </Grid>
      <Grid item>
        <span className={`${styles.label} ${styles.county}`}>County</span>
        <span className={`${styles.text} ${disabled && styles.disabled}`}>{county || '---'}</span>
      </Grid>
    </Grid>
  </>
)
